import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "font-bold" }

import { Button } from '@/components/ui/button';
    import {
        Dialog,
        DialogContent,
        DialogHeader,
        DialogTitle,
        DialogClose,
        DialogFooter,
        DialogDescription,
        DialogBody,
    } from '@/components/ui/dialog';
    import { computed, watch } from 'vue';
    import { toast } from 'vue-sonner';
    import { useForm, usePage } from '@inertiajs/vue3';
    import { useI18n } from 'vue-i18n';
    import type { SharedData, Voucher } from '@/types';
    import { useQueryClient } from '@tanstack/vue-query';
    import QueryKey from '@/enums/QueryKey';
    import { useVoucherStore } from '@/stores/voucher';
    import VoucherMarkAsMissingForm from '@/components/vouchers/VoucherMarkAsMissingForm.vue';
    import type { Table } from '@tanstack/vue-table';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'BulkMarkAsMissingVouchersDialog',
  props: {
    table: {}
  },
  setup(__props: any) {

    const props = __props;

    const voucherStore = useVoucherStore();
    const page = usePage<SharedData>();
    const companyId = computed(() => page.props.auth.user.selected_company_id);

    const { t } = useI18n();
    const queryClient = useQueryClient();

    const form = useForm({
        ids: [] as number[],
        account: null,
        comment: null,
    });

    const handleUpload = () => {
        form.post(route('v2.voucher.admin.mark-as-missing.selection'), {
            preserveScroll: true,
            onSuccess: () => {
                form.resetAndClearErrors();
                toast.success(t('vouchers.select.mark_as_missing_responses.success'));
                props.table.resetRowSelection();
                queryClient.invalidateQueries({ queryKey: [QueryKey.VOUCHERS, companyId] });
                voucherStore.toggleOpen('mark_as_missing', false);
            },
            onError: (error: any) => {
                if (error instanceof Error) {
                    toast.error(t('forms.system_error'));
                }
            },
        });
    };

    watch(
        () => voucherStore.validVoucherIds,
        (newIds) => {
            form.ids = newIds;
        },
        { immediate: true },
    );

return (_ctx: any,_cache: any) => {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createBlock(_unref(Dialog), {
    open: _unref(voucherStore).markAsMissingModalOpen,
    "onUpdate:open": _cache[1] || (_cache[1] = (value) => _unref(voucherStore).toggleOpen('mark_as_missing', value))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DialogContent), { class: "sm:max-w-lg" }, {
        default: _withCtx(() => [
          _createElementVNode("form", {
            onSubmit: _withModifiers(handleUpload, ["prevent"]),
            class: "flex max-h-full flex-col overflow-hidden"
          }, [
            _createVNode(_unref(DialogHeader), null, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogTitle), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('vouchers.select.mark_as_missing_confirm.title')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(DialogBody), { class: "space-y-5" }, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogDescription), { class: "flex flex-col gap-2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_i18n_t, {
                      keypath: "vouchers.select.mark_as_missing_confirm.content",
                      tag: "span",
                      scope: "global"
                    }, {
                      body: _withCtx(() => [
                        _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(voucherStore).validVoucherNumbers), 1)
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" " + _toDisplayString(_unref(t)('vouchers.select.mark_as_missing_confirm.description')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(VoucherMarkAsMissingForm, {
                  form: _unref(form),
                  "company-id": companyId.value
                }, null, 8, ["form", "company-id"])
              ]),
              _: 1
            }),
            _createVNode(_unref(DialogFooter), { class: "gap-2 border-t sm:justify-center" }, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogClose), { "as-child": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Button), {
                      variant: "outline",
                      size: "sm",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(form).resetAndClearErrors()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('forms.cancel')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Button), {
                  disabled: _unref(form).processing,
                  loading: _unref(form).processing,
                  size: "sm"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('forms.yes')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "loading"])
              ]),
              _: 1
            })
          ], 32)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})